import React, { memo, useState } from 'react'
import Checkbox from '@mui/material/Checkbox'
import CheckboxUnchecked from 'Assets/images/checkbox_unchecked.svg'
import CheckboxChecked from 'Assets/images/checkbox_checked.svg'
import {useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'
import {
  ContractSection,
  ContractSectionHeader,
} from 'Components/shared/contracts'
import { Table } from 'Components/shared/table'
import { selectContractConfiguration } from 'Slices/contracts/ContractConfigurationSlice'
import { ContractType } from 'Types/index'

const NoSegments = styled('div')(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.dark,
}))

interface SegmentsListProps {
  segments: any
  flattenSegments: any
  columnData: any
  handleRowClick: (rowIdx: number) => void
}

export const SegmentsListSection = memo(
  ({
    segments,
    flattenSegments,
    columnData,
    handleRowClick,
  }: SegmentsListProps) => {
    const { segment_fill_type, contractSource, contractType } = useSelector(selectContractConfiguration);
    const [inactiveFiltered, setInactiveFiltered] = useState(false)

    const toggleInactive = (e: React.MouseEvent) => {
      e.stopPropagation()
      e.preventDefault()
      setInactiveFiltered((prev) => !prev)
    }

    const filteredSegments = inactiveFiltered
      ? flattenSegments.filter((segment: any) => segment[6] !== 'Deactivated' && segment[5] !== 'Complete' && segment[5] !== 'Deactivated')
      : flattenSegments;

    return (
      <ContractSection>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}><ContractSectionHeader label={'Segments'} />
        {(filteredSegments.length > 1 || inactiveFiltered) && <div style={{marginRight: '40px', marginBottom: '54px'}}>Hide {`${contractType === ContractType.on_demand ? 'Completed' : 'Disabled'} `} Segments<Checkbox
            key='inactive-toggle'
            icon={<CheckboxUnchecked />}
            checkedIcon={<CheckboxChecked />}
            checked={inactiveFiltered}
            onClick={toggleInactive}
          /> </div>}
          </div>
        {segments && segments.length > 0 ? (<>
          <Table
            width={'calc(100% - 56px)'}
            height={'248px'}
            columnData={columnData}
            rows={filteredSegments}
            variant='striped'
            handleRowClick={handleRowClick}
            disabled={false}
            sortable={segment_fill_type === 'manual_sort'}
          />
         
        </>) : (
          <NoSegments>No segments have been added to this contract</NoSegments>
        )}
      </ContractSection>
    )

  }
)
